export default __webpack_public_path__ + "static/media/outcome.6eb96d30.svg";